export default "__VITE_ASSET__0gtboqy9__"